import React from 'react';
import '../../styles/home/FeedTabs.scss';

const FeedTabs = ({ tabs, activeTabIdx, setActiveTabIdx }) => {
  return (
    <div className='feed-tabs-container'>
      <div className='tabs-row'>
        {tabs.map((tab, idx) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTabIdx === idx ? 'active' : ''}`}
            onClick={() => setActiveTabIdx(idx)}
            type='button'>
            {tab.label}
          </button>
        ))}
      </div>
      <div className='tab-indicator-container'>
        <div
          className='tab-indicator'
          style={{ width: `${(100 / tabs.length).toFixed(3)}%`, transform: `translateX(${activeTabIdx * 100}%)` }}
        />
      </div>
    </div>
  );
};

export default FeedTabs;
